import { setStoreValue } from "@/store/utils";

export const SET_APPROVAL_CHAIN_TEMPLATES = "SET_APPROVAL_CHAIN_TEMPLATES";
export const SET_IS_FETCHING_APPROVAL_CHAINS =
  "SET_IS_FETCHING_APPROVAL_CHAINS";
export const SET_CURRENT_APPROVAL_CHAIN = "SET_CURRENT_APPROVAL_CHAIN";
export const SET_IS_FETCHING_CURRENT_APPROVAL_CHAIN =
  "SET_IS_FETCHING_CURRENT_APPROVAL_CHAIN";

const mutations = {
  [SET_APPROVAL_CHAIN_TEMPLATES]: setStoreValue("approvalChainTemplates"),
  [SET_IS_FETCHING_APPROVAL_CHAINS]: setStoreValue("isFetchingApprovalChains"),
  [SET_CURRENT_APPROVAL_CHAIN]: setStoreValue("currentApprovalChain"),
  [SET_IS_FETCHING_CURRENT_APPROVAL_CHAIN]: setStoreValue(
    "isFetchingCurrentApprovalChain"
  )
};

const state = {
  approvalChainTemplates: [],
  isFetchingApprovalChains: false,
  currentApprovalChain: {},
  isFetchingCurrentApprovalChain: false
};

export { mutations, state };
